import React from 'react';
import './ConfirmDeleteDialog.css';

interface ConfirmDeleteDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  poleName: string;
  hasCassette: boolean;
  splicesCount: number;
  splittersCount: number;
  cablesCount: number;
  onusCount: number;
}

const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  poleName,
  hasCassette,
  splicesCount,
  splittersCount,
  cablesCount,
  onusCount
}) => {
  console.log('🗑️ ConfirmDeleteDialog render:', { isOpen, poleName });

  if (!isOpen) return null;

  const hasData = hasCassette || cablesCount > 0 || onusCount > 0;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content confirm-delete-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>⚠️ Potvrdiť vymazanie</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="warning-message">
            <p className="pole-name">Naozaj chcete vymazať stĺpik <strong>"{poleName}"</strong>?</p>
            
            {hasData && (
              <div className="data-summary">
                <p className="warning-text">⚠️ Tento stĺpik obsahuje:</p>
                <ul className="data-list">
                  {hasCassette && (
                    <li>
                      <strong>Kazeta</strong> s {splicesCount} zvarmi a {splittersCount} splittermi
                    </li>
                  )}
                  {cablesCount > 0 && (
                    <li>
                      <strong>{cablesCount}</strong> {cablesCount === 1 ? 'kábel' : cablesCount < 5 ? 'káble' : 'káblov'}
                    </li>
                  )}
                  {onusCount > 0 && (
                    <li>
                      <strong>{onusCount}</strong> {onusCount === 1 ? 'ONU' : 'ONUs'}
                    </li>
                  )}
                </ul>
                <p className="danger-text">
                  🔴 Všetky tieto dáta budú vymazané!
                </p>
              </div>
            )}

            <div className="undo-info">
              <p className="info-text">
                ℹ️ Po vymazaní budete mať <strong>10 sekúnd</strong> na vrátenie zmeny pomocou tlačidla "Undo".
              </p>
              <p className="info-text">
                📸 Automaticky sa vytvorí záloha projektu, ktorú môžete neskôr obnoviť.
              </p>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Zrušiť
          </button>
          <button className="btn-danger" onClick={onConfirm}>
            Áno, vymazať
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteDialog;

